export default __webpack_public_path__ + "static/media/thumbnail-w-cushion@2x.c572ee21.png";